import React from "react";
import HeadingSection from '../components/module/HeadingSection';
import ModuleCard from '../components/module/ModuleCard';
import ImgAuthenticator from '../assets/authenticator.png';
import ImgInvoice from '../assets/invoice.png';
import ImgInventoryAccounting from '../assets/inventory_accounting.png';
import ImgPointOfSales from '../assets/pointofsales.png';
import ImgLoyalty from '../assets/loyalty.png';

export default function Modules() {
  const moduleData = [
    {
      image: ImgAuthenticator,
      alt: "Authenticator",
      title: "Authenticator - Secure Your Supply Chain",
      description: "Eliminate fake items and build customer trust with our QR-based authentication engine.",
      features: [
        {
          title: "Individual Unit Labeling: ",
          description: "Give every item its own digital identity, regardless of lot or batch size."
        },
        {
          title: "Real-Time Logistics Tracking: ",
          description: "Gain full visibility into your inventory's movement."
        },
        {
          title: "Warranty Activation: ",
          description: "Provide a seamless experience with embedded warranty claims."
        }
      ]
    },
    {
      image: ImgInvoice,
      alt: "Invoice",
      title: "Invoice - Get Paid Faster, Reconcile Sooner",
      description: "Stop chasing paper and start growing your business with an integrated sales invoice system.",
      features: [
        {
          title: "Go Paperless: ",
          description: "Easily transform your traditional invoicing into a secure digital format."
        },
        {
          title: "Connected Payments: ",
          description: "Integrated with banks and fintech for instant settlement."
        },
        {
          title: "Zero-Friction Reconciliation: ",
          description: "Minimize the hours spent on manual audits with automated transaction logs."
        }
      ]
    },
    {
      image: ImgInventoryAccounting,
      alt: "Inventory",
      title: "Inventory + Accounting - The Core",
      description: "One system to master your inventory, sales, and books. Experience the power of a truly unified system.",
      features: [
        {
          title: "Unified Operations: ",
          description: "Seamlessly link your purchasing, sales, and inventory data to eliminate manual entries."
        },
        {
          title: "Flexible Structure: ",
          description: "Build a Chart of Accounts that fits your business model."
        },
        {
          title: "Versatile Inventory: ",
          description: "Manage inventory, purchase orders, and sales cycles within a single, high-performance environment."
        }
      ]
    },
    {
      image: ImgPointOfSales,
      alt: "Point of Sales",
      title: "Point of Sales - Seamless Checkout, Anywhere.",
      description: "A high-performance checkout experience fully connected to your warehouse, loyalty programs, and financial books.",
      features: [
        {
          title: "Device Flexibility: ",
          description: "Optimized for mobile, tablet, and traditional workstations."
        },
        {
          title: "Ecosystem Ready: ",
          description: "Fully integrated with your wider Business OS suite, giving you a fully synchronized business engine."
        },
        {
          title: "Industry Adaptive: ",
          description: "Designed to provide a strategic advantage across diverse business sectors."
        }
      ]
    }
  ];

  const loyaltyModule = {
    image: ImgLoyalty,
    alt: "Loyalty",
    title: "Loyalty - Smart Retention Engine.",
    description: "Boost your customer lifetime value with a customizable rewards system.",
    features: [
      {
        title: "Flexible Formats: ",
        description: "Whether you prefer digital stamps or accruable points."
      },
      {
        title: "Seamless Deployment: ",
        description: "A low-friction system that integrates directly into your existing checkout flow."
      },
      {
        title: "Incentivize Growth: ",
        description: "Encourage repeat visits by rewarding your most loyal customers effortlessly."
      }
    ]
  };

  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/dist/tabler-icons.min.css"
      />
      <div className="w-full bg-neutral-100 min-h-[screen]">
        <section className="py-16 w-full bg-neutral-100 max-sm:py-10">
          <div className="px-6 mx-auto max-w-[1200px]">
            <HeadingSection />
            <div className="grid grid-cols-2 gap-6 max-md:grid-cols-1 max-sm:gap-4">
              {moduleData.map((module, index) => (
                <ModuleCard
                  key={index}
                  image={module.image}
                  alt={module.alt}
                  title={module.title}
                  description={module.description}
                  features={module.features}
                />
              ))}
            </div>
            <div className="mt-6 max-md:mt-4">
              <ModuleCard
                image={loyaltyModule.image}
                alt={loyaltyModule.alt}
                title={loyaltyModule.title}
                description={loyaltyModule.description}
                features={loyaltyModule.features}
                className="max-w-[calc(50%-12px)] max-md:max-w-full"
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
